import { useLocalShortcut } from 'admin/lib/shortcuts'
import { Matchers } from 'admin/lib/Records'

export function useLineItemShortcuts(onRemove, onDuplicate) {
  const shortcutRemove = useLocalShortcut(
    Matchers.lineItems.removeCurrent,
    onRemove
  )

  const shortcutDuplicate = useLocalShortcut(
    Matchers.lineItems.duplicate,
    onDuplicate,
    {
      existingOnKeyDown: shortcutRemove.onKeyDown
    }
  )

  return shortcutDuplicate
}
